module.exports = __webpack_public_path__ + "static/media/3 baku japanese yokai creature mythology tattoo forearm sleeve blackwork.1280x1707.bf9f5e85.webp";